import { render, staticRenderFns } from "./EmailVerificationForm.vue?vue&type=template&id=fd36eefe&scoped=true&lang=pug"
import script from "./EmailVerificationForm.vue?vue&type=script&lang=js"
export * from "./EmailVerificationForm.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationForm.vue?vue&type=style&index=0&id=fd36eefe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd36eefe",
  null
  
)

export default component.exports